import { FC, createElement, type JSX } from 'react'
import { cn } from '../utils/cn'

import type { CreateComponentsUnion } from '../types'

type CoverProps = CreateComponentsUnion<
  keyof JSX.IntrinsicElements,
  {
    fullSize?: boolean
  }
>

export const Cover: FC<CoverProps> = ({
  as = 'div',
  fullSize = false,
  className,
  children,
  ...props
}) => {
  const coverClassName = cn(
    'relative flex w-full flex-col items-center justify-center',
    className,
    {
      'h-full': fullSize
    }
  )
  return createElement(as, { ...props, className: coverClassName }, children)
}
